import * as React from "react";
import Metatags from "@ADC/components/Metatags";
import {
  Header,
  Home,
  Article,
} from "@ADC/components/Pages/ServiceAreasLanders/DebtRelief";
import { HighIncome } from "@ADC/components/Views";
import NotFoundPage from "@ADC/pages/404";
import { NewForm, Footer } from "@ADC/components/Pages/ServiceAreasLanders";

const IndividualDebtConsolidationInPage = (props) => {
  const {
    serverData: { data },
  } = props;
  const {
    phoneNumber,
    heroSectionImage,
    heroSectionVideo,
    heroSectionTitle,
    heroSectionDescription,
    isArticle,
    address,
    name,
    afterArticleCTA,
    articleContent,
  } = data?.attributes || {};
  const defaultDesc =
    "Affordable Debt Consolidation helps Texas residents struggling with unsecured debt find relief through our Texas Debt Relief Program. We specialize in debt consolidation, credit counseling, and financial education. Our approach ensures you regain control of your finances and eliminate debt burdens. Let us guide you toward a brighter financial future.";

  if (!data) {
    return <NotFoundPage />;
  } else {
    return (
      <React.Fragment>
        <Header phoneNumber={phoneNumber} />
        <Home
          name={name}
          heroSectionImage={heroSectionImage}
          heroSectionVideo={heroSectionVideo}
        />
        <HighIncome
          phoneNumber={phoneNumber}
          heroSectionTitle={heroSectionTitle}
          heroSectionDescription={
            heroSectionDescription ? heroSectionDescription : defaultDesc
          }
          defaultDesc={defaultDesc}
        />
        {isArticle && (
          <section className="py-16">
            <Article content={articleContent.slice(0, 5)} />
            <div className="border-y my-6">
              <NewForm name={name} />
            </div>
            <Article
              content={articleContent.slice(5, articleContent.length)}
              afterArticleCTA={afterArticleCTA}
            />
          </section>
        )}

        <Footer address={address} phoneNumber={phoneNumber} />
      </React.Fragment>
    );
  }
};

export default IndividualDebtConsolidationInPage;

export const Head = ({ serverData: { data } }) => {
  return (
    <Metatags
      pageTitle={data?.attributes?.metaTitle}
      metaTitle={data?.attributes?.metxaTitle}
      description={data?.attributes?.metaDescription}
      keywords={data?.attributes?.metaKeywords}
      imageUrl={data?.attributes?.metaImage?.data?.attributes?.url}
      datePublished={data?.attributes?.publishedAt}
      dateModified={data?.attributes?.updatedAt}
      type="article"
    />
  );
};

export async function getServerData({ params: { slug } }) {
  try {
    const res = await fetch(
      `${process.env.ADC_API_URL}/adc-debt-settlement-in-landers?populate=*&sort=id:asc&filters[path][$eq]=/${slug}/`
    );

    if (!res.ok) {
      throw new Error(`Response failed`);
    }
    const data = await res.json();

    if (data?.data?.length) {
      return {
        props: { data: data?.data[0] },
      };
    } else {
      return {
        props: { data: null },
      };
    }
  } catch (error) {
    return {
      status: 500,
      headers: {},
      props: {},
    };
  }
}
